import { Microphone, MicrophoneSlash, Hourglass, SpeakerHigh } from '@phosphor-icons/react';
import { cn } from '@/lib/utils';
import type { VoiceState } from '../lib/voice-session';

/* Affiche le statut de la session vocale en cours (connexion / parle / écoute).
 * Rendu uniquement quand voiceLive est vrai. */
export function VoiceStatusBar({
  voiceLive,
  voiceState,
  maxWidth,
}: {
  voiceLive: boolean;
  voiceState: VoiceState;
  /* max-width du conteneur parent (ex: 760 ou 820). Défaut : '100%'. */
  maxWidth?: number;
}) {
  if (!voiceLive) return null;
  const icon =
    voiceState === 'connecting' ? <Hourglass size={14} className="animate-pulse" />
    : voiceState === 'speaking'  ? <SpeakerHigh size={14} />
    : <Microphone size={14} />;
  const label =
    voiceState === 'connecting' ? 'Connexion…'
    : voiceState === 'speaking'  ? 'Naïa parle…'
    : "Parle, je t'écoute";
  return (
    <div className="mx-auto mb-2 flex items-center gap-1.5 text-[13px] font-bold text-muted-foreground" style={{ maxWidth }}>
      {icon}
      {label}
    </div>
  );
}

/* Bouton micro toggle (start/stop) partagé entre les chats pro.
 * Affiche 🎙️ quand inactif, ■ quand la session est active. */
export function VoiceMicButton({
  voiceLive,
  streaming,
  onToggle,
}: {
  voiceLive: boolean;
  /* Désactive le bouton pendant qu'un tour texte est en cours. */
  streaming: boolean;
  onToggle: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      disabled={streaming}
      aria-label={voiceLive ? 'Arrêter la voix' : 'Parler'}
      className={cn(
        "flex-none w-12 h-11 flex items-center justify-center p-0 bg-card border border-border rounded-card cursor-pointer font-[inherit] text-foreground disabled:cursor-not-allowed",
        voiceLive && "bg-naia-error border-none text-card",
      )}
    >
      {voiceLive ? <MicrophoneSlash size={20} /> : <Microphone size={20} />}
    </button>
  );
}
